import { RenderInDesktop } from '@ui/components/MobileOrDesktop';
import {
  ModalOrDragDrawerContent,
  ModalOrDrawer,
  ModalOrDrawerCloseButton,
  ModalOrDrawerHeader,
  ModalOrDrawerOverlay,
} from '@ui/components/ModalOrDrawer';
import {
  TransactionError,
  TransactionPending,
} from '@ui/components/TransactionDrawer';
import { useTranslations } from '@ui/i18n';

import { DefaultContent } from './DefaultContent';
import { SuccessContent } from './SuccessContent';
import { useDepositDrawer } from './useDepositDrawer';
import { LiquidityStrategyStep } from './utils';

export const DepositDrawer = () => {
  const t = useTranslations();

  const isOpen = useDepositDrawer((s) => s.isOpen);
  const onClose = useDepositDrawer((s) => s.onClose);
  const isWithdraw = useDepositDrawer((s) => s.isWithdraw);
  const step = useDepositDrawer((s) => s.step);
  const pendingNSteps = useDepositDrawer((s) => s.pendingNSteps);
  const pendingCurrentStep = useDepositDrawer((s) => s.pendingCurrentStep);
  const error = useDepositDrawer((s) => s.error);

  return (
    <ModalOrDrawer
      placement="bottom"
      scrollBehavior="inside"
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOrDrawerOverlay />
      <ModalOrDragDrawerContent minH={{ base: '60vh', desktop: '600px' }}>
        <ModalOrDrawerHeader>
          {isWithdraw
            ? t('Liquid strategy withdraw')
            : t('Liquid strategy deposit')}
        </ModalOrDrawerHeader>
        <RenderInDesktop>
          <ModalOrDrawerCloseButton />
        </RenderInDesktop>
        {step === LiquidityStrategyStep.default && <DefaultContent />}
        {step === LiquidityStrategyStep.pending && (
          <TransactionPending.Content
            nSteps={pendingNSteps}
            currentStep={pendingCurrentStep}
          />
        )}
        {step === LiquidityStrategyStep.failed && (
          <TransactionError.Content error={error} />
        )}
        {step === LiquidityStrategyStep.success && <SuccessContent />}
      </ModalOrDragDrawerContent>
    </ModalOrDrawer>
  );
};
